/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./auth-card-header.component";
var styles_AuthCardHeaderComponent = [];
var RenderType_AuthCardHeaderComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_AuthCardHeaderComponent, data: {} });
export { RenderType_AuthCardHeaderComponent as RenderType_AuthCardHeaderComponent };
export function View_AuthCardHeaderComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "h4", [["class", "text-primary"]], null, null, null, null, null)), i0.ɵncd(null, 0)], null, null); }
export function View_AuthCardHeaderComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-auth-card-header", [], null, null, null, View_AuthCardHeaderComponent_0, RenderType_AuthCardHeaderComponent)), i0.ɵdid(1, 114688, null, 0, i1.AuthCardHeaderComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AuthCardHeaderComponentNgFactory = i0.ɵccf("app-auth-card-header", i1.AuthCardHeaderComponent, View_AuthCardHeaderComponent_Host_0, {}, {}, ["*"]);
export { AuthCardHeaderComponentNgFactory as AuthCardHeaderComponentNgFactory };
